var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-5",attrs:{"img-src":_vm.file.url,"img-alt":_vm.file.title}},[_vm._t("content",function(){return [_c('p',[_vm._v(_vm._s(_vm.file.file_name))])]}),_vm._v(" "),_c('template',{slot:"footer"},[_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }